// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, SumType, SumTypeVariant, DatabaseTable, AlgebraicValue, ReducerEvent, Identity, Address, ClientDB, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";
// @ts-ignore
import { ImageElementData } from "./image_element_data";

export class ImageElement extends DatabaseTable
{
	public static db: ClientDB = __SPACETIMEDB__.clientDB;
	public static tableName = "ImageElement";
	public imageElementData: ImageElementData;
	public width: number;
	public height: number;

	public static primaryKey: string | undefined = undefined;

	constructor(imageElementData: ImageElementData, width: number, height: number) {
	super();
		this.imageElementData = imageElementData;
		this.width = width;
		this.height = height;
	}

	public static serialize(value: ImageElement): object {
		return [
		ImageElementData.serialize(value.imageElementData), value.width, value.height
		];
	}

	public static getAlgebraicType(): AlgebraicType
	{
		return AlgebraicType.createProductType([
			new ProductTypeElement("imageElementData", ImageElementData.getAlgebraicType()),
			new ProductTypeElement("width", AlgebraicType.createPrimitiveType(BuiltinType.Type.I32)),
			new ProductTypeElement("height", AlgebraicType.createPrimitiveType(BuiltinType.Type.I32)),
		]);
	}

	public static fromValue(value: AlgebraicValue): ImageElement
	{
		let productValue = value.asProductValue();
		let __ImageElementData = ImageElementData.fromValue(productValue.elements[0]);
		let __Width = productValue.elements[1].asNumber();
		let __Height = productValue.elements[2].asNumber();
		return new this(__ImageElementData, __Width, __Height);
	}

}

export default ImageElement;
